"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { CircleCheck, Phone } from "lucide-react";
export default function ProfessionalRoofRepairServices() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll();
  const {
    ref: descRef,
    isVisible: descVisible
  } = useRevealOnScroll();
  const {
    ref: bulletsRef,
    isVisible: bulletsVisible
  } = useRevealOnScroll();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll();
  const services = [{
    id: 1,
    text: "Detailed professional roof inspections"
  }, {
    id: 2,
    text: "Full damage documentation for insurance"
  }, {
    id: 3,
    text: "Customized repair & restoration plans"
  }, {
    id: 4,
    text: "Comprehensive labor & material warranties"
  }, {
    id: 5,
    text: "24/7 emergency leak response"
  }];
  const serviceAreas = [{
    id: 1,
    name: "Montgomery County",
    path: "/ServiceAreasPage"
  }, {
    id: 2,
    name: "Howard County",
    path: "/ServiceAreasPage"
  }, {
    id: 3,
    name: "Frederick County",
    path: "/ServiceAreasPage"
  }, {
    id: 4,
    name: "Northern Virginia",
    path: "/ServiceAreasPage"
  }, {
    id: 5,
    name: "View All Service Areas",
    path: "/ServiceAreasPage"
  }];
  return <section id="professional-roof-repair-services" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        {}
        <div ref={headlineRef} className={`mb-8 transition-all duration-700 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-default text-4xl md:text-5xl font-bold text-foreground mb-4" style={{
          color: "var(--primary-500)"
        }}>
            Roof Repair Experts in Maryland & Northern Virginia.
          </h1>
          <nav className="flex flex-wrap items-center gap-2 text-sm font-default mb-6 text-muted-foreground">
            <span className="font-semibold text-foreground">Serving:</span>
            {serviceAreas.map((area, i) => <div key={area.id} data-index={i} className="flex items-center">
                <Link to={area.path} className="hover:text-secondary transition-colors">
                  {area.name}
                </Link>
                {i < serviceAreas.length - 1 && <span className="mx-2 text-border">|</span>}
              </div>)}
          </nav>
          <div className="h-1 w-24 rounded-lg" style={{
          backgroundColor: "var(--secondary-500)"
        }} />
        </div>

        {}
        <div ref={descRef} className={`mb-12 transition-all duration-700 delay-100 ${descVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-default text-lg text-foreground mb-4">With over 10 years of specialized roofing expertise, we provide roof repairs built to last tailored to the unique weather challenges of the Mid-Atlantic. Our certified technicians utilize advanced diagnostic tools and premium materials to restore your home's structural integrity.</p>
          <p className="font-default text-base text-foreground opacity-90">Whether you're dealing with a leak, missing shingles, or storm damage, our experienced technicians diagnose the problem, explain your options, and complete lasting repairs using premium materials.</p>
          <p className="font-default text-base font-semibold text-primary mt-4">Fully licensed, insured. Trusted by Maryland homeowners.</p>
          <p className="font-default text-base text-foreground mt-2 opacity-80">
            Serving homeowners in Montgomery County, Howard County, Frederick County, and Northern Virginia communities.
          </p>
        </div>

        {}
        <Card className="mb-12 bg-card shadow-lg border border-border">
          <CardHeader>
            <CardTitle className="font-default text-2xl text-foreground">What to Expect</CardTitle>
          </CardHeader>
          <CardContent>
            <div ref={bulletsRef} className={`space-y-4 transition-all duration-700 delay-200 ${bulletsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              {services.map((service, i) => <div key={service.id} data-index={i} className="flex items-start gap-4">
                  <CircleCheck className="flex-shrink-0 mt-1" size={24} style={{
                color: "var(--secondary-500)"
              }} />
                  <p className="font-default text-foreground text-base">
                    {service.text}
                  </p>
                </div>)}
            </div>
          </CardContent>
        </Card>

        {}
        <div ref={ctaRef} className={`bg-muted rounded-lg p-8 md:p-12 text-center transition-all duration-700 delay-300 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-2xl md:text-3xl font-bold text-foreground mb-6">
            Catch Problems Early & Save
          </h2>
          <p className="font-default text-foreground mb-8 max-w-2xl mx-auto">
            Catch problems early when repairs are simpler and more affordable. 
            Schedule your free professional assessment today to prevent costly 
            water damage and extend the life of your existing roof.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/ContactPage">
              <Button size="lg" className="w-full sm:w-auto font-default font-semibold" style={{
              backgroundColor: "var(--secondary-500)",
              color: "var(--secondary-foreground)"
            }}>
                Schedule Your Free 30‑Minute Assessment
              </Button>
            </Link>
            <Button size="lg" variant="outline" className="w-full sm:w-auto font-default font-semibold flex items-center justify-center gap-2" onClick={() => window.location.href = "tel:"}>
              <Phone size={20} />
              Call Now
            </Button>
          </div>
        </div>
      </div>
    </section>;
}